// extracted by mini-css-extract-plugin
export default {"adminLayout":"adminLayout_adminLayout__RDp3N","wrapper":"adminLayout_wrapper__hSuNo","content":"adminLayout_content__yyvz4"};